import App from "../../../core/src/App";
import GameModel from "../../../core/src/model/GameModel";
import ConsoleUtil from "../../../core/src/utils/ConsoleUtil";
import Utils from "../../../core/src/utils/Utils";
import GetGameRequest from "./GetGameRequest";

export default class GetHistoryRequest extends GetGameRequest {
  get requestData(): any {

    return {
      "action": "getLastPlayHistory",
      "userId": GameModel?.playerConfig?.userId,
      "gameId": App.config.gameId
    };
  };
};